import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PhoneCall } from "lucide-react";
import { usePhoneBar } from "@/contexts/PhoneBarContext";

export const Coupons = () => {
  const { phoneNumber } = usePhoneBar();
  const coupons = [
    {
      amount: "$200",
      type: "OFF",
      service: "Any Roof Repairs",
      minimum: "*minimum purchase of $1000 required",
      bgColor: "bg-blue-900"
    },
    {
      amount: "$500", 
      type: "OFF",
      service: "Any New Roof",
      minimum: "*minimum purchase of $9000 required",
      bgColor: "bg-blue-800"
    },
    {
      amount: "20%",
      type: "OFF", 
      service: "Chimney Repairs",
      minimum: "*minimum purchase of $800 required",
      bgColor: "bg-blue-700"
    }
  ];

  return (
    <section id="coupons" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Coupons
          </h2>
          <p className="text-xl text-muted-foreground">
            Save money on your next roofing project with our exclusive offers!
          </p>
        </div>

        {/* Coupons Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {coupons.map((coupon, index) => (
            <Card key={index} className={`${coupon.bgColor} border-0 text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2`}>
              <CardContent className="p-8 text-center space-y-4">
                <div className="space-y-2">
                  <div className="text-6xl font-bold">{coupon.amount}</div>
                  <div className="text-2xl font-semibold opacity-90">{coupon.type}</div>
                </div>
                
                <div className="border-t border-white/20 pt-4">
                  <h3 className="text-xl font-bold mb-2">{coupon.service}</h3>
                  <p className="text-sm opacity-75">{coupon.minimum}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-lg text-muted-foreground mb-6">
            Call now to claim your discount and schedule your free estimate!
          </p>
          <Button
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold px-8 py-4 text-lg shadow-lg hover:shadow-xl transition-all duration-200"
            onClick={() => window.location.href = `tel:${phoneNumber}`}
          >
            <PhoneCall className="w-5 h-5 mr-3" />
            {phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}
          </Button>
        </div>
      </div>
    </section>
  );
};